import {createFileRoute} from '@tanstack/react-router';
import {LoanAccountPPIClosePage} from 'features/loans/pages/LoanAccountPPIClosePage/LoanAccountPPIClosePage';

export const Route = createFileRoute(
  '/_protected/accounts/loans/$accountId/ppi/close/confirm',
)({
  component: LoanAccountPPIClosePage,
});
